// dependancies
import React from "react";
import PropTypes from "prop-types";

// styles
import TabStyled from "./Tab.styled";

const Tab = props => {
    const { children, active, click } = props;
    return (
        <TabStyled active={active} type="button" onClick={click} role="tab" aria-selected={active}>
            {children}
        </TabStyled>
    );
};

Tab.propTypes = {
    children: PropTypes.node,
    click: PropTypes.func,
    active: PropTypes.bool
};

export default Tab;
